import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import MiniDrawer from './components/Header';
import Footer from './components/Footer';
import TutorialButton from './components/TutorialButton';
import TutorialGuide from './components/TutorialGuide';
import { TutorialProvider } from './context/TutorialContext';
import { Outlet } from 'react-router-dom';
import { headerOptions } from './constants/headerOptions';
import { authCsrfUrl } from './constants/urls';
import { useAuth } from './context/AuthContext';
import { useDarkModeSync } from './hooks/useDarkModeSync';
import './App.css';

function App() {
  const { user } = useAuth();
  const theme = useDarkModeSync();
  // En web el menú arranca abierto y mantiene el estado que elija el usuario al navegar; en mobile arranca cerrado.
  // 599.95px = breakpoint 'sm' de MUI, el mismo que usa Header para decidir si es mobile.
  const [drawerOpen, setDrawerOpen] = useState(() => !window.matchMedia('(max-width:599.95px)').matches);

  // Fuerza Django para que cree la cookie csrftoken apenas arranca la app.
  useEffect(() => {
    axios.get(authCsrfUrl, { withCredentials: true }).catch(() => {});
  }, []);

  // Los items sin `roles` son visibles para cualquier usuario logueado.
  const visibleOptions = headerOptions.filter((opt) => !opt.roles || opt.roles.includes(user?.role));

  // TutorialProvider va acá (y no en index.js) porque necesita el usuario logueado y el router;
  // las pantallas de impresión quedan fuera del layout y no muestran el botón de tutoriales.
  return (
    <ThemeProvider theme={theme}>
      <TutorialProvider>
        <div className="App h-[100svh] flex flex-col overflow-hidden bg-surface">
          <MiniDrawer
            title='La Huerta'
            menuOptions={visibleOptions}
            open={drawerOpen}
            onOpenChange={setDrawerOpen}
          />
          {/* Mismo ancho de drawer (240/65) que Header y Footer aplican por su cuenta: Tailwind
              necesita las clases arbitrarias completas y literales para compilarlas, así que no
              se puede centralizar en una constante interpolada sin romper el JIT. */}
          <main
            className={`flex-grow overflow-y-auto px-4 sm:px-8 py-6 transition-[margin-left] duration-200 ease-in-out ${
              drawerOpen ? 'sm:ml-[240px]' : 'sm:ml-[65px]'
            }`}
          >
            <Outlet />
          </main>
          <Footer open={drawerOpen} />
          <TutorialButton />
          <TutorialGuide />
        </div>
      </TutorialProvider>
    </ThemeProvider>
  );
}

export default App;